{
  "signup": {
    "preview": "Confirm your email to activate your BidNova Auctions account",
    "heading": "Confirm your email",
    "body1": "Welcome to BidNova Auctions — the UK's premier marketplace for graded Pokémon cards.",
    "body2": "Please confirm your email address{recipientSuffix} to activate your account and start bidding in GBP.",
    "recipientSuffix": " ({recipient})",
    "cta": "Verify email address",
    "footer": "This link is single-use and expires shortly. If you didn't create an account, you can safely ignore this email.",
    "subject": "Confirm your email"
  },
  "recovery": {
    "preview": "Reset your BidNova Auctions password",
    "heading": "Reset your password",
    "body1": "We received a request to reset the password on your BidNova Auctions account. Click the button below to choose a new one.",
    "cta": "Reset password",
    "footer": "This link is single-use and expires shortly. If you didn't request a password reset you can safely ignore this email — your password will not be changed.",
    "subject": "Reset your password"
  },
  "magicLink": {
    "preview": "Your BidNova Auctions login link",
    "heading": "Your login link",
    "body": "Click the button below to sign in to BidNova Auctions. This link will expire shortly.",
    "cta": "Log in",
    "footer": "If you didn't request this link you can safely ignore this email.",
    "subject": "Your login link"
  },
  "emailChange": {
    "preview": "Confirm your email change for {siteName}",
    "heading": "Confirm your email change",
    "body1": "You requested to change your email address for {siteName} from {oldEmail} to {newEmail}.",
    "body2": "Click the button below to confirm this change:",
    "cta": "Confirm Email Change",
    "footer": "If you didn't request this change, please secure your account immediately.",
    "subject": "Confirm your new email"
  },
  "reauthentication": {
    "preview": "Your verification code",
    "heading": "Confirm reauthentication",
    "body": "Use the code below to confirm your identity:",
    "footer": "This code will expire shortly. If you didn't request this, you can safely ignore this email.",
    "subject": "Your verification code"
  },
  "invite": {
    "preview": "You've been invited to join {siteName}",
    "heading": "You've been invited",
    "body": "You've been invited to join {siteName}. Click the button below to accept the invitation and create your account.",
    "cta": "Accept Invitation",
    "footer": "If you weren't expecting this invitation, you can safely ignore this email.",
    "subject": "You've been invited"
  },
  "newBidReceived": {
    "preview": "New bid on {auctionTitle}",
    "previewFallback": "New bid on your auction",
    "heading": "You've got a new bid",
    "bidderFallback": "A collector",
    "auctionFallback": "your listing",
    "body": "{bidder} just placed a bid on {auctionTitle}.",
    "keyValueLabel": "Current top bid",
    "bodyWatch": "Watch the auction live and keep an eye on activity as the timer ticks down.",
    "cta": "View auction",
    "subject": "New bid on {auctionTitle}",
    "subjectFallback": "You have a new bid"
  },
  "outbid": {
    "preview": "You have been outbid",
    "heading": "You've been outbid",
    "auctionFallback": "an auction",
    "body": "Someone placed a higher bid on {auctionTitle}.",
    "keyValueLabel": "Current top bid",
    "bodyJump": "Jump back in before the timer runs out.",
    "cta": "Place a higher bid",
    "subject": "You've been outbid on {auctionTitle}"
  },
  "auctionWon": {
    "preview": "You won! Complete payment to secure your card.",
    "heading": "You won 🏆",
    "auctionFallback": "the auction",
    "body1": "Congratulations — you won {auctionTitle}.",
    "body2": "Complete payment within 48 hours to finalise your order and get it shipped.",
    "cta": "Pay now",
    "subject": "You won {auctionTitle} — payment required"
  },
  "auctionLost": {
    "preview": "Auction ended",
    "heading": "Auction ended",
    "auctionFallback": "the auction",
    "auctionFallbackShort": "an auction",
    "bodyDefault": "Unfortunately your bid on {auctionTitle} was not the winning one.",
    "bodyMore": "Plenty more graded grails are coming up — take another look.",
    "cta": "Browse live auctions",
    "subject": "Auction ended: {auctionTitle}"
  },
  "auctionEndingSoon": {
    "preview": "An auction you're watching is ending soon",
    "heading": "Ending soon",
    "auctionFallback": "An auction",
    "endsInFallback": "1 hour",
    "body": "{auctionTitle} ends in {endsIn}.",
    "keyValueLabel": "Current top bid",
    "cta": "Place your bid",
    "subject": "Ending soon: {auctionTitle}"
  },
  "orderCreated": {
    "preview": "A buyer needs to pay for your item",
    "heading": "Order created",
    "auctionFallback": "listing",
    "bodyWithAmount": "Your auction {auctionTitle} ended with a winning bid of {amount}.",
    "bodyNoAmount": "Your auction {auctionTitle} ended with a winning bid.",
    "body2": "We'll notify you again as soon as the buyer completes payment. Then you'll be able to ship the card and mark the order dispatched.",
    "cta": "Open dashboard",
    "subject": "Order created for {auctionTitle}"
  },
  "orderPaid": {
    "preview": "Payment confirmed",
    "heading": "Payment confirmed",
    "orderFallback": "your order",
    "bodyWithAmount": "Your payment of {amount} for {auctionTitle} is confirmed.",
    "bodyNoAmount": "Your payment for {auctionTitle} is confirmed.",
    "body2": "The seller has been notified and will ship shortly. You'll receive another email when tracking is available.",
    "body3WithNumber": "Your receipt ({invoiceNumber}) is attached below and always available from your Orders page.",
    "body3NoNumber": "Your receipt is attached below and always available from your Orders page.",
    "ctaReceipt": "Download receipt (PDF)",
    "ctaOrder": "View order",
    "subject": "Payment confirmed for {auctionTitle}"
  },
  "orderCompleted": {
    "preview": "Order complete — {auctionTitle}",
    "heading": "Order complete",
    "cardFallback": "the card",
    "bodySeller": "Your order for {auctionTitle} is now fully complete. Your payout has been released and the buyer has left feedback.",
    "bodyBuyer": "Your order for {auctionTitle} is now fully complete. The seller has been paid and the transaction is closed.",
    "keyValueLabel": "Order total",
    "body2": "Thanks for using BidNova Auctions. Leave a review to help other collectors and sellers.",
    "cta": "View order",
    "subjectWithTitle": "Order complete — {auctionTitle}",
    "subjectFallback": "Your order is complete"
  },
  "paymentReceivedSeller": {
    "preview": "You've been paid — ship the card",
    "heading": "Payment received",
    "listingFallback": "your listing",
    "bodyWithAmount": "Great news — the buyer has paid {amount} for {auctionTitle}.",
    "bodyNoAmount": "Great news — the buyer has paid for {auctionTitle}.",
    "body2": "Please ship the card within 3 business days and mark it shipped with the tracking number.",
    "body3WithNumber": "Your sales invoice ({invoiceNumber}) is available below and from your Seller dashboard.",
    "body3NoNumber": "Your sales invoice is available below and from your Seller dashboard.",
    "ctaInvoice": "Download invoice (PDF)",
    "ctaDashboard": "Go to seller dashboard",
    "subject": "Payment received for {auctionTitle} — please ship"
  },
  "itemShipped": {
    "preview": "Your order has shipped",
    "heading": "Your order is on the way",
    "cardFallback": "Your card",
    "body1": "{auctionTitle} has been dispatched by the seller.",
    "keyValueLabel": "Tracking number",
    "body2": "Please confirm delivery in your orders page once it arrives so the seller can be paid out.",
    "cta": "View order",
    "subject": "Shipped: {auctionTitle}",
    "orderFallback": "your order"
  },
  "trackingAvailable": {
    "preview": "Your Royal Mail tracking number is ready",
    "heading": "Your tracking number is ready",
    "orderFallback": "your order",
    "carrierFallback": "Royal Mail",
    "body1": "A shipping label has been created for {auctionTitle}. The seller will drop it off with {carrier} shortly.",
    "keyValueLabel": "Tracking number",
    "cta": "Track your parcel",
    "footer": "You can also view your order and tracking any time at {ordersUrl}.",
    "subject": "Tracking number for {auctionTitle}"
  },
  "deliveryConfirmed": {
    "preview": "Buyer confirmed delivery",
    "heading": "Delivery confirmed",
    "cardFallback": "the card",
    "saleFallback": "your sale",
    "body1": "The buyer has confirmed delivery of {auctionTitle}.",
    "body2": "Your payout will be released by our team shortly, minus the 8% platform commission.",
    "cta": "Open dashboard",
    "subject": "Delivery confirmed for {auctionTitle}"
  },
  "sellerPayout": {
    "preview": "Your payout has been released",
    "heading": "Payout released",
    "saleFallback": "your sale",
    "bodyWithAmount": "Your payout of {amount} for {auctionTitle} has been released to your Stripe account.",
    "bodyNoAmount": "Your payout for {auctionTitle} has been released to your Stripe account.",
    "keyValueLabel": "Payout reference",
    "footer": "Funds typically arrive within 1–2 business days.",
    "cta": "Open dashboard",
    "subject": "Payout released for {auctionTitle}"
  },
  "refundCompleted": {
    "heading": "Refund completed",
    "bodySeller": "A refund has been completed for one of your orders.",
    "bodyBuyer": "Your refund has been completed and will appear on your original payment method shortly.",
    "itemLabel": "Item",
    "amountLabel": "Amount",
    "cta": "View order",
    "subject": "Refund completed"
  },
  "listingApproved": {
    "preview": "Your listing is live",
    "heading": "Your listing is approved",
    "listingFallback": "Your listing",
    "body": "{auctionTitle} has been approved and is now live on BidNova.",
    "cta": "View listing",
    "subject": "Listing approved: {auctionTitle}",
    "itemFallback": "your item"
  },
  "listingRejected": {
    "preview": "Listing needs changes",
    "heading": "Listing needs changes",
    "body": "Your listing {auctionTitle} couldn't be approved as submitted.",
    "reasonLabel": "Reason",
    "body2": "You can edit and resubmit it from your seller dashboard.",
    "cta": "Edit listing",
    "subject": "Listing needs changes: {auctionTitle}",
    "itemFallback": "your item"
  },
  "welcome": {
    "preview": "Welcome to BidNova Auctions",
    "headingWithName": "Welcome, {displayName}!",
    "headingPlain": "Welcome!",
    "body1": "Thanks for joining BidNova Auctions — the UK's premier marketplace for graded Pokémon cards.",
    "body2": "Browse live auctions, place bids in GBP, and secure the grail you've been hunting.",
    "cta": "Browse live auctions",
    "footer": "Selling too? Complete Stripe verification in your dashboard to list your first card.",
    "subject": "Welcome to BidNova Auctions"
  },
  "disputeNotification": {
    "headlineDefault": "Dispute update",
    "introDefault": "There is an update on a dispute related to your order.",
    "orderLabel": "Order",
    "itemLabel": "Item",
    "statusLabel": "Dispute status",
    "actionRequiredLabel": "Action required",
    "notAvailable": "—",
    "cta": "View dispute",
    "footer": "You are receiving this because you are a party to this dispute. Full details, messages and evidence are always available in the Dispute Centre.",
    "subjectDefault": "Dispute update"
  },
  "watchlistNewBid": {
    "preview": "A new bid on your watched auction",
    "heading": "New bid on your watched auction",
    "auctionFallback": "an auction you're watching",
    "body": "A new bid has been placed on {auctionTitle}.",
    "keyValueLabel": "Current top bid",
    "cta": "View auction",
    "subject": "New bid on {auctionTitle}",
    "subjectFallback": "a watched auction"
  },
  "auctionBelowReserve": {
    "preview": "Your auction ended below reserve",
    "heading": "Auction ended below reserve",
    "auctionFallback": "your auction",
    "body": "Your listing {auctionTitle} ended without meeting the reserve price, so no sale has been completed.",
    "highestBidLabel": "Highest bid",
    "reserveLabel": "Reserve",
    "body2": "You can relist the item at any time from your seller dashboard.",
    "cta": "Relist item",
    "subject": "Reserve not met on {auctionTitle}"
  },
  "paymentReminder": {
    "preview": "Payment reminder for your winning bid",
    "heading": "Payment reminder",
    "orderFallback": "your order",
    "bodyWithAmount": "You still need to complete payment for {auctionTitle} ({amount}).",
    "bodyNoAmount": "You still need to complete payment for {auctionTitle}.",
    "body2": "Orders left unpaid may be cancelled and offered to the next highest bidder.",
    "cta": "Pay now",
    "subject": "Reminder: pay for {auctionTitle}"
  },
  "adminAlert": {
    "subjectFallback": "Platform alert",
    "body": "An event on BidNova Auctions needs your attention.",
    "cta": "Open admin dashboard",
    "subjectPrefix": "[BidNova Auctions] {subject}"
  }
}